import { memo, PropsWithChildren } from 'react';
import { Text } from '../../text';

export const Label = memo(({ children }: PropsWithChildren<unknown>) => (
  <Text role="presentation">{children}</Text>
));

Label.displayName = 'Dropdown.Label';
